export default __webpack_public_path__ + "static/do-use-return-urls-279191ea15b8b861ba8912b0da6c7a9c.png";